export default __webpack_public_path__ + "static/accusatory-15513188c27ebf0ff1802b97eb70fc47.svg";